<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
     document.title = "论文及科普作品投稿系统";
  }
}
</script>

<style lang="less">
@import './assets/css/reset.css';
#app {
  width: 100%;
  height: 1080px;
  min-width: 1900px;
  button {
    cursor: pointer;
  }
  .login_ftr {
    margin: 58px auto 0;
    width: 520px;
    height: 39px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #00599e;
    text-align: center;
    p {
      margin: 0 auto;
      width: 520px;
      line-height: 2;
    }
  }
}
</style>
